var HB_PRICE_TEXT = HAMPER_CONFIG.currency + " " + HAMPER_CONFIG.fixed_price.toFixed(2);

var selected = {};
var catProducts = {};
var lbCard = null;
var lbImages = [];
var lbSizes = [];
var lbSize = null;
var toastTimer = null;

var $ = function(id){ return document.getElementById(id); };
function esc(s){ return String(s || "").replace(/"/g, "&quot;"); }
function escHTML(s){ return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"); }

/* Size variants from Shopify. A product with no size options has a single "Default Title" variant -> []. */
function variantAvailable(v){
  return !(v.available === false
    || (v.inventory_management && v.inventory_policy !== "continue" && v.inventory_quantity <= 0))
    && gbLeft(v.id) > 0;
}
/* 2026-10-22: stock is shared with the cart and with the other steps of this set, so the last piece
   can't be ordered twice (e.g. a hamper pick + the same piece on À La Carte, or Romper 1 = Romper 2).
   GB_STOCK (written by the page) = the shop's stock of each limited variant.
   gbSlot = the step being drawn / picked: its own pick doesn't count against itself. */
var gbSlot = null;
function gbStock(id){ var s = (window.GB_STOCK || {})[id]; return s == null ? null : s; }
function gbLeft(id){
  var stock = gbStock(id);
  if (stock == null) return Infinity;
  var used = GBCart.usedQty(id);
  Object.keys(selected).forEach(function(k){ if (k !== gbSlot && String(selected[k].variantId) === String(id)) used++; });
  return stock - used;
}
function gbRedrawCards(){ HAMPER_CONFIG.categories.forEach(function(c, i){ rerenderCat(i); }); }
function getSizes(p){
  var vs = p.variants || [];
  if (vs.length <= 1 && (!vs[0] || vs[0].title === "Default Title")) return [];
  var options = p.options || [];
  var size = options.find(function(o){
    return /^(size|المقاس|مقاس|الحجم)$/i.test(o.name) || (o.values && o.values.length > 0
      && o.values.every(function(value){ return /^\d+(?:\s*-\s*\d+)?\s*months?$/i.test(value); }));
  });
  var fixedColor = options.find(function(o){
    return /^(colou?r|اللون|لون)$/i.test(o.name) && o.values && o.values.length === 1;
  });
  var sizeKey = options.length === 2 && size && fixedColor && size !== fixedColor ? "option" + size.position : null;
  return vs.map(function(v){ return { id: v.id, title: (sizeKey && v[sizeKey]) || v.title, available: variantAvailable(v) }; });
}
/* No Size variants? Fall back to the sizes typed in the "Size" category metafield (display only, not pickable). */
function metaSizesHTML(p){
  var labels = (window.GB_SIZE_LABELS || {})[p.id] || [];
  if (!labels.length) return '';
  return '<p class="hb-card-sizes"><span class="hb-card-sizes-lbl">' + (labels.length > 1 ? HB_STRINGS.sizes_label : HB_STRINGS.size_label) + ':</span> '
    + labels.map(function(t){ return '<span class="hb-card-size">' + escHTML(t) + '</span>'; }).join('')
    + '</p>';
}
function displayName(sel){
  return sel.size ? sel.name + " \u2014 " + HB_STRINGS.size_label + " " + sel.size : sel.name;
}

/* Ask Shopify's CDN for a resized image instead of the full-size original. */
function imgW(u, w){
  if (!/(^|\/\/)cdn\.shopify\.com\/|\/cdn\/shop\//.test(u)) return u;
  u = u.replace(/([?&])width=\d+(&|$)/, function(m, a, b){ return b ? a : ""; });
  return u + (u.indexOf("?") > -1 ? "&" : "?") + "width=" + w;
}
/* 2026-10-23: card photos in the size the screen needs (cards are ~150-180px wide on phones,
   ~360px on tablets, <=280px on computers) instead of always 600px: about half the data on phones. */
var GB_CARD_SIZES = "(max-width: 960px) 47vw, 280px";
function imgSet(u){ return [240, 360, 480, 600].map(function(w){ return imgW(u, w) + " " + w + "w"; }).join(", "); }
function getImages(p){
  var imgs = (p.images || []).map(function(i){ return imgW(i.src || i, 1200); }).filter(Boolean);
  if (!imgs.length && p.image && p.image.src) imgs = [imgW(p.image.src, 1200)];
  if (!imgs.length) imgs = ["https://placehold.co/800x800/f7f3ee/c9a96e?text=."];
  return imgs;
}


function cardHTML(prod, catKey, catName){
  gbSlot = catKey;
  var v = prod.variants[0];
  var imgs = getImages(prod);
  var sizes = getSizes(prod);
  var picked = selected[catKey] && String(selected[catKey].productId) === String(prod.id);
  var outOfStock = sizes.length
    ? !sizes.some(function(sz){ return sz.available; })
    : !variantAvailable(v);
  var sizesHTML = sizes.length
    ? '<p class="hb-card-sizes"><span class="hb-card-sizes-lbl">' + HB_STRINGS.sizes_label + ':</span> '
      + sizes.map(function(sz){ return '<span class="hb-card-size' + (sz.available ? '' : ' hb-card-size-oos') + '">' + escHTML(sz.title) + '</span>'; }).join('')
      + '</p>'
    : metaSizesHTML(prod);
  return '<button type="button" class="hb-card' + (picked ? ' hb-picked' : '') + (outOfStock ? ' hb-oos' : '') + '"'
    + ' data-cat="' + catKey + '" data-catname="' + esc(catName) + '" data-variant="' + v.id + '" data-product="' + prod.id + '" data-sizes="' + encodeURIComponent(JSON.stringify(sizes)) + '"'
    + ' data-name="' + esc(prod.title) + '" data-handle="' + esc(prod.handle) + '" data-desc="' + esc((prod.body_html || '').replace(/<[^>]*>/g, '').substring(0, 300)) + '"'
    + ' data-thumb="' + imgs[0] + '" data-images="' + encodeURIComponent(JSON.stringify(imgs)) + '" onclick="openLB(this)">'
    + '<div class="hb-card-media"><img src="' + imgW(imgs[0], 600) + '" srcset="' + imgSet(imgs[0]) + '" sizes="' + GB_CARD_SIZES + '" alt="' + esc(prod.title) + '" loading="lazy"/>'
    + (imgs.length > 1 ? '<div class="hb-card-badge">' + imgs.length + ' ' + HB_STRINGS.photos_badge + '</div>' : '')
    + (outOfStock ? '<div class="hb-oos-badge">' + HB_STRINGS.out_of_stock + '</div>' : '')
    + (picked ? '<div class="hb-card-sel"><span class="hb-card-sel-check">&#10003;</span> ' + HB_STRINGS.selected_badge + '</div>' : '')
    + '</div><div class="hb-card-info"><p class="hb-card-name">' + prod.title + '</p>' + sizesHTML + '</div></button>';
}

function sectionHTML(cat, prods, i){
  var key = "c" + i, sel = selected[key];
  var grid = prods.length
    ? '<div class="hb-grid">' + prods.map(function(p){ return cardHTML(p, key, cat.name); }).join("") + '</div>'
    : '<p class="hb-empty">' + HB_STRINGS.no_products + '</p>';
  return '<section class="hb-section hb-sec-' + i + '" id="sec-' + key + '">'
    + '<button type="button" class="hb-acc-head" onclick="toggleSec(\'' + key + '\')">'
    + '<div class="hb-acc-left"><div class="hb-acc-num">'
    + '<div class="hb-step-badge' + (sel ? ' hb-step-done' : '') + '" id="step-' + key + '">' + (sel ? '&#10003;' : (i + 1)) + '</div>'
    + '</div><div><p class="hb-acc-title">' + cat.name + '</p>'
    + '<p class="hb-acc-hint">' + HB_STRINGS.step_of.replace('{current}', i + 1).replace('{total}', HAMPER_CONFIG.categories.length) + ' &nbsp;·&nbsp; ' + prods.length + ' ' + HB_STRINGS.items_count + '</p></div></div>'
    + '<div class="hb-acc-right">'
    + '<span class="hb-pill' + (sel ? ' done' : '') + '" id="pill-' + key + '">' + (sel ? sel.name : HB_STRINGS.not_selected) + '</span>'
    + '<span class="hb-arrow" id="arrow-' + key + '">&#8964;</span></div></button>'
    + '<div class="hb-acc-body" id="body-' + key + '"><div class="hb-acc-inner">' + grid + '</div></div></section>';
}

function rerenderCat(i){
  var cat = HAMPER_CONFIG.categories[i], key = "c" + i;
  var pill = $("pill-" + key), body = $("body-" + key), stepBadge = $("step-" + key);
  if (pill) { pill.textContent = selected[key] ? displayName(selected[key]) : HB_STRINGS.not_selected; pill.className = "hb-pill" + (selected[key] ? " done" : ""); }
  if (stepBadge) { stepBadge.innerHTML = selected[key] ? "&#10003;" : (i + 1); stepBadge.className = "hb-step-badge" + (selected[key] ? " hb-step-done" : ""); }
  if (body && catProducts[key]) {
    body.querySelector(".hb-acc-inner").innerHTML = catProducts[key].length
      ? '<div class="hb-grid">' + catProducts[key].map(function(p){ return cardHTML(p, key, cat.name); }).join("") + '</div>'
      : '<p class="hb-empty">' + HB_STRINGS.no_products + '</p>';
  }
}

function toggleSec(key){
  var sec = $("sec-" + key), arrow = $("arrow-" + key);
  if (!sec) return;
  var open = sec.classList.contains("hb-open");
  document.querySelectorAll(".hb-section").forEach(function(s){ s.classList.remove("hb-open"); });
  document.querySelectorAll(".hb-arrow").forEach(function(a){ a.classList.remove("hb-rot"); });
  if (!open) { sec.classList.add("hb-open"); if (arrow) arrow.classList.add("hb-rot"); gbPinStep(key); setTimeout(function(){ scrollToEl(sec); }, 60); }
}

function openSec(key){
  var sec = $("sec-" + key), arrow = $("arrow-" + key);
  if (!sec) return;
  if (window.innerWidth <= 960) {
    document.querySelectorAll(".hb-section").forEach(function(s){ s.classList.remove("hb-open"); });
    document.querySelectorAll(".hb-arrow").forEach(function(a){ a.classList.remove("hb-rot"); });
    var d = $("hb-drawer");
    if (d && d.classList.contains("hb-open")) { d.classList.remove("hb-open"); document.body.style.overflow = ""; }
    var exp = $("hb-bar-expand"); if (exp) exp.innerHTML = "&#8593;";
  }
  sec.classList.add("hb-open"); if (arrow) arrow.classList.add("hb-rot");
  gbPinStep(key);
  setTimeout(function(){ scrollToEl(sec); }, 80);
}

function openDrawerSelection(key){
  var d = $("hb-drawer");
  if (d && d.classList.contains("hb-open")) { d.classList.remove("hb-open"); document.body.style.overflow = ""; var exp = $("hb-bar-expand"); if (exp) exp.innerHTML = "&#8593;"; }
  openSec(key);
}

function scrollToEl(el){
  var sw = document.querySelector(".hb-sticky-wrap");
  window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - (sw ? sw.offsetHeight + 16 : 16), behavior: "smooth" });
}

// 2026-10-16: the step the customer opens stays highlighted until they scroll by hand. Before, the last steps
// (near the bottom of the page) could never scroll up to the line below, so an earlier step (e.g. "Socks") stayed highlighted.
var gbActiveStep = -1, gbPinnedStep = -1;
function gbMarkStep(i){
  gbActiveStep = i;
  var tabs = $("hb-tabs"); if (!tabs) return;
  tabs.querySelectorAll(".hb-tab").forEach(function(t, j){ t.classList.toggle("hb-tab-active", j === i); });
  var at = tabs.querySelector(".hb-tab-active");
  if (at) tabs.scrollTo({ left: at.offsetLeft - (tabs.offsetWidth / 2) + (at.offsetWidth / 2), behavior: "smooth" });
}
function gbPinStep(key){
  if (window.innerWidth > 960) return;
  gbPinnedStep = parseInt(String(key).replace("c", ""), 10);
  gbMarkStep(gbPinnedStep);
}

function initScrollSpy(){
  if (window.innerWidth > 960) return;
  ["touchstart", "wheel", "keydown"].forEach(function(ev){ window.addEventListener(ev, function(){ gbPinnedStep = -1; }, { passive: true }); });
  window.addEventListener("scroll", function(){
    if (gbPinnedStep >= 0) { gbMarkStep(gbPinnedStep); return; }
    var sw = document.querySelector(".hb-sticky-wrap"), off = (sw ? sw.offsetHeight : 0) + 60, cur = 0;
    var atBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 4;
    HAMPER_CONFIG.categories.forEach(function(c, i){
      var s = $("sec-c" + i); if (!s) return;
      var top = s.getBoundingClientRect().top;
      if (top <= off || (atBottom && top < window.innerHeight - 100)) cur = i; // at the bottom: the last step whose title is on screen
    });
    gbMarkStep(cur);
  }, { passive: true });
}

function showToast(msg, type){
  var t = $("hb-toast"); if (!t) return;
  t.textContent = msg;
  t.className = "hb-toast hb-toast-show" + (type === "success" ? " hb-toast-success" : "");
  clearTimeout(toastTimer); toastTimer = setTimeout(function(){ t.className = "hb-toast"; }, 2600);
}

function openLB(card){
  lbCard = card;
  try { lbImages = JSON.parse(decodeURIComponent(card.dataset.images || "[]")); } catch (e) { lbImages = [card.dataset.thumb]; }
  if (!lbImages.length) lbImages = [card.dataset.thumb];
  setLBImg(0);
  $("hb-lb-cat").textContent = card.dataset.catname;
  $("hb-lb-name").textContent = card.dataset.name;
  var descEl = $("hb-lb-desc"); if (descEl) descEl.textContent = card.dataset.desc || "";
  var pick = $("hb-lb-pick");
  var isOos = card.classList.contains("hb-oos");
  var already = selected[card.dataset.cat] && String(selected[card.dataset.cat].productId) === String(card.dataset.product);

  /* size picker — only for products that have size variants in Shopify */
  try { lbSizes = JSON.parse(decodeURIComponent(card.dataset.sizes || "[]")); } catch (e) { lbSizes = []; }
  lbSize = null;
  if (already && selected[card.dataset.cat].size) {
    lbSize = lbSizes.filter(function(sz){ return sz.title === selected[card.dataset.cat].size; })[0] || null;
  }
  if (!lbSize) lbSize = gbOnlySize();
  renderLBSizes(!!already || isOos);

  if (isOos) {
    pick.textContent = HB_STRINGS.out_of_stock; pick.disabled = true; pick.style.opacity = "0.5"; pick.style.cursor = "not-allowed"; pick.onclick = null;
  } else if (already) {
    pick.textContent = HB_STRINGS.lb_remove; pick.classList.add("hb-lb-pick-remove");
    pick.disabled = false; pick.style.opacity = ""; pick.style.cursor = "";
    pick.onclick = function(){ unselectItem(card.dataset.cat); closeLB(); };
  } else {
    pick.textContent = HB_STRINGS.lb_select; pick.classList.remove("hb-lb-pick-remove");
    pick.disabled = false; pick.style.opacity = ""; pick.style.cursor = ""; pick.onclick = selectFromLB;
  }
  $("hb-lb").classList.add("hb-lb-open"); document.body.style.overflow = "hidden";
}

function setLBImg(i){
  $("hb-lb-img").src = lbImages[i];
  $("hb-lb-thumbs").innerHTML = lbImages.map(function(src, j){
    return '<button type="button" class="hb-thumb' + (j === i ? ' active' : '') + '" onclick="setLBImg(' + j + ')"><img src="' + imgW(src, 200) + '" alt=""></button>';
  }).join("");
}

/* 2026-10-15: when only ONE size is in stock (sold-out sizes don't count), pick it automatically
   and just show "Size: X" instead of asking the customer to choose. */
function gbOnlySize(){
  var av = lbSizes.filter(function(sz){ return sz.available; });
  return av.length === 1 ? av[0] : null;
}
function gbOnlySizeLabel(sz){
  return escHTML(HB_STRINGS.size_label) + ': <span style="text-transform:none;letter-spacing:.02em;color:var(--text);font-size:1.15em;margin-inline-start:4px">' + escHTML(sz.title) + '</span>';
}
function renderLBSizes(locked){
  var wrap = $("hb-lb-sizes"), chips = $("hb-size-chips"), lbl = $("hb-lb-size-label");
  if (!wrap || !chips) return;
  if (!lbSizes.length) {
    var labels = (window.GB_SIZE_LABELS || {})[lbCard.dataset.product] || [];
    wrap.style.display = labels.length === 1 ? "" : "none";
    if (lbl && labels.length === 1) lbl.innerHTML = gbOnlySizeLabel({title: labels[0]});
    chips.innerHTML = "";
    return;
  }
  wrap.style.display = "";
  var only = gbOnlySize();
  if (only && (!lbSize || String(lbSize.id) === String(only.id))) { if (lbl) lbl.innerHTML = gbOnlySizeLabel(only); chips.innerHTML = ""; return; }
  if (lbl) lbl.textContent = (locked && lbSize) ? HB_STRINGS.size_label : HB_STRINGS.choose_size;
  chips.innerHTML = lbSizes.map(function(sz, i){
    var cls = "hb-size-chip" + (lbSize && lbSize.id === sz.id ? " active" : "") + (sz.available ? "" : " hb-size-chip-oos");
    var dis = (!sz.available || locked) ? " disabled" : "";
    return '<button type="button" class="' + cls + '"' + dis + ' onclick="pickLBSize(' + i + ')">' + escHTML(sz.title) + '</button>';
  }).join("");
}
function pickLBSize(i){
  var sz = lbSizes[i];
  if (!sz || !sz.available) return;
  lbSize = sz;
  renderLBSizes(false);
}
function closeLB(){ $("hb-lb").classList.remove("hb-lb-open"); document.body.style.overflow = ""; lbCard = null; lbImages = []; lbSizes = []; lbSize = null; }
function selectFromLB(){
  if (!lbCard) return;
  if (lbSizes.length && !lbSize) {
    showToast(HB_STRINGS.size_required);
    var chips = $("hb-size-chips"); if (chips) { chips.classList.remove("hb-shake"); void chips.offsetWidth; chips.classList.add("hb-shake"); }
    return;
  }
  gbSlot = lbCard.dataset.cat;
  if (gbLeft(lbSize ? lbSize.id : lbCard.dataset.variant) <= 0) { closeLB(); gbRedrawCards(); showToast(GBCart.t.taken); return; }
  var key = lbCard.dataset.cat, catI = parseInt(key.replace("c", ""), 10), savedScroll = window.scrollY;
  selected[key] = {
    productId: lbCard.dataset.product,
    variantId: lbSize ? String(lbSize.id) : lbCard.dataset.variant,
    name: lbCard.dataset.name,
    size: lbSize ? lbSize.title : "",
    img: lbCard.dataset.thumb,
    handle: lbCard.dataset.handle,
    stock: gbStock(lbSize ? lbSize.id : lbCard.dataset.variant)
  };
  var name = displayName(selected[key]);
  closeLB(); rerenderCat(catI); updateAll();
  var sec = $("sec-" + key), arrow = $("arrow-" + key);
  if (sec) sec.classList.remove("hb-open"); if (arrow) arrow.classList.remove("hb-rot");
  var done = Object.keys(selected).length, total = HAMPER_CONFIG.categories.length;
  if (done === total) {
    showToast(HB_STRINGS.toast_all_done, "success");
  } else {
    var nextCat = HAMPER_CONFIG.categories[catI + 1];
    if (nextCat) showToast(HB_STRINGS.toast_added.replace('{name}', name).replace('{next}', nextCat.name), "success");
    var nextKey = "c" + (catI + 1);
    if ($("sec-" + nextKey)) setTimeout(function(){ openSec(nextKey); }, 320);
    else requestAnimationFrame(function(){ window.scrollTo({ top: savedScroll, behavior: "auto" }); });
  }
}

function removeFromDrawer(key){ delete selected[key]; rerenderCat(parseInt(key.replace("c", ""), 10)); updateAll(); buildDrawer(); showToast(HB_STRINGS.toast_removed); }
function unselectItem(key){ delete selected[key]; rerenderCat(parseInt(key.replace("c", ""), 10)); updateAll(); buildDrawer(); showToast(HB_STRINGS.toast_removed); }

function buildTabs(){
  var el = $("hb-tabs"); if (!el) return;
  el.innerHTML = HAMPER_CONFIG.categories.map(function(c, i){
    var key = "c" + i, done = !!selected[key];
    return '<button type="button" class="hb-tab' + (done ? ' hb-tab-done' : '') + (i === gbActiveStep ? ' hb-tab-active' : '') + '" onclick="openSec(\'' + key + '\')">' + (done ? '&#10003; ' : '') + c.name + '</button>';
  }).join("");
}

function buildPanel(){
  var done = Object.keys(selected).length, total = HAMPER_CONFIG.categories.length;
  var sub = $("hb-panel-sub"); if (sub) sub.textContent = HB_STRINGS.panel_sub.replace('{done}', done).replace('{total}', total);
  var fill = $("hb-ring-fill"); if (fill) fill.style.strokeDashoffset = 213.6 * (1 - done / total);
  var rdone = $("hb-ring-done"); if (rdone) rdone.textContent = done;
  var rtotal = $("hb-ring-total"); if (rtotal) rtotal.textContent = total;
  var iHTML = HAMPER_CONFIG.categories.map(function(cat, i){
    var key = "c" + i, sel = selected[key];
    if (sel) return '<div class="hb-pi-wrap"><div class="hb-pi hb-pi-filled"><button type="button" class="hb-pi-main" onclick="openSec(\'' + key + '\')">'
      + '<img class="hb-pi-img" src="' + sel.img + '" alt=""><div class="hb-pi-info"><p class="hb-pi-cat">' + cat.name + '</p><p class="hb-pi-name">' + sel.name + '</p>' + (sel.size ? '<p class="hb-pi-size">' + HB_STRINGS.size_label + ': ' + escHTML(sel.size) + '</p>' : '') + '</div>'
      + '<div class="hb-pi-tick">&#10003;</div></button><button type="button" class="hb-pi-rm" onclick="unselectItem(\'' + key + '\')">&#10005;</button></div></div>';
    return '<button type="button" class="hb-pi-wrap hb-pi-empty" onclick="openSec(\'' + key + '\')">'
      + '<div class="hb-pi"><div class="hb-pi-icon">' + (i + 1) + '</div>'
      + '<div class="hb-pi-info"><p class="hb-pi-cat">' + cat.name + '</p><p class="hb-pi-name hb-na">' + HB_STRINGS.tap_to_choose + '</p></div></div></button>';
  }).join("");
  var el = $("hb-panel-items"); if (el) el.innerHTML = iHTML;
  var cta = $("hb-panel-cta"), ctaTxt = $("hb-panel-cta-text");
  if (cta && ctaTxt) { cta.disabled = done !== total; ctaTxt.textContent = done === total ? HB_STRINGS.cta_purchase : HB_STRINGS.cta_select_all.replace('{total}', total); cta.onclick = done === total ? addToCart : null; }
  var fill2 = $("hb-progress-fill"); if (fill2) fill2.style.width = (done / total * 100) + "%";
  var pt = $("hb-prog-text");
  if (pt) { if (done === 0) pt.textContent = HB_STRINGS.progress_start; else if (done === total) pt.textContent = HB_STRINGS.progress_done; else pt.textContent = HB_STRINGS.progress_partial.replace('{done}', done).replace('{total}', total); }
  var pf = $("hb-prog-frac"); if (pf) pf.textContent = done + " / " + total;
}

function buildBar(){
  var done = Object.keys(selected).length, total = HAMPER_CONFIG.categories.length;
  var stEl = $("hb-bar-steps");
  if (stEl) stEl.innerHTML = HAMPER_CONFIG.categories.map(function(c, i){
    return (i > 0 ? '<div class="hb-bar-line"></div>' : '') + '<div class="hb-bar-dot' + (selected["c" + i] ? ' done' : '') + '">' + (selected["c" + i] ? '&#10003;' : (i + 1)) + '</div>';
  }).join("");
  var bt = $("hb-bar-total"); if (bt) bt.textContent = HB_PRICE_TEXT;
  var cta = $("hb-bar-cta"), txt = $("hb-bar-cta-txt"), banner = $("hb-purchase-banner"), bar = $("hb-bar");
  if (cta && txt) {
    cta.disabled = false;
    if (done === total) {
      txt.textContent = HB_STRINGS.cta_purchase; cta.onclick = addToCart; cta.classList.add("hb-bar-cta-ready");
      if (banner && window.innerWidth <= 960) { banner.style.display = "block"; bar.style.display = "none"; }
    } else {
      txt.textContent = HB_STRINGS.view_count.replace('{done}', done).replace('{total}', total); cta.onclick = toggleDrawer; cta.classList.remove("hb-bar-cta-ready");
      if (banner) { banner.style.display = "none"; if (window.innerWidth <= 960) bar.style.display = "flex"; }
    }
  }
}

function buildDrawer(){
  var done = Object.keys(selected).length, total = HAMPER_CONFIG.categories.length;
  var iHTML = HAMPER_CONFIG.categories.map(function(cat, i){
    var key = "c" + i, sel = selected[key];
    if (sel) return '<div class="hb-di-wrap"><div class="hb-di"><button type="button" class="hb-di-main" onclick="openDrawerSelection(\'' + key + '\')">'
      + '<img class="hb-di-img" src="' + sel.img + '" alt=""><div class="hb-di-info"><p class="hb-pi-cat">' + cat.name + '</p><p class="hb-pi-name">' + sel.name + '</p>' + (sel.size ? '<p class="hb-pi-size">' + HB_STRINGS.size_label + ': ' + escHTML(sel.size) + '</p>' : '') + '</div>'
      + '</button><div class="hb-di-actions"><div class="hb-di-tick">&#10003;</div><button type="button" class="hb-di-rm" onclick="removeFromDrawer(\'' + key + '\')">&#10005;</button></div></div></div>';
    return '<button type="button" class="hb-di hb-di-empty" onclick="openSec(\'' + key + '\')">'
      + '<div class="hb-di-num">' + (i + 1) + '</div><div class="hb-di-info"><p class="hb-pi-cat">' + cat.name + '</p><p class="hb-pi-name hb-na">' + HB_STRINGS.not_selected_yet + '</p></div></button>';
  }).join("");
  var el = $("hb-drawer-items"); if (el) el.innerHTML = iHTML;
  var tHTML = '<div class="hb-tl hb-tl-grand"><span>' + HB_STRINGS.hamper_total + '</span><span>' + HB_PRICE_TEXT + '</span></div><div class="hb-tl-delivery">🚚 ' + HB_STRINGS.delivery_line + '</div>';
  tHTML += done === total
    ? '<button class="hb-mdr-cta" onclick="addToCart()">' + HB_STRINGS.cta_purchase + '</button>'
    : '<button class="hb-mdr-cta hb-mdr-cta-dim" disabled>' + HB_STRINGS.panel_sub.replace('{done}', done).replace('{total}', total) + '</button>';
  var tel = $("hb-drawer-totals"); if (tel) tel.innerHTML = tHTML;
}

function toggleDrawer(){
  var d = $("hb-drawer"), btn = $("hb-bar-expand"), open = d.classList.contains("hb-open");
  if (open) { d.classList.remove("hb-open"); document.body.style.overflow = ""; if (btn) btn.innerHTML = "&#8593;"; }
  else { buildDrawer(); d.classList.add("hb-open"); document.body.style.overflow = "hidden"; if (btn) btn.innerHTML = "&#8595;"; }
}

var checkoutBusy = false;

function setCheckoutBusy(busy){
  checkoutBusy = busy;
  var btn = $("hb-panel-cta"), txt = $("hb-panel-cta-text"), mbtn = $("hb-bar-cta"), mtxt = $("hb-bar-cta-txt");
  if (btn) { btn.disabled = busy; if (txt) txt.textContent = busy ? HB_STRINGS.cta_processing : HB_STRINGS.cta_purchase; }
  if (mbtn) { mbtn.disabled = busy; if (mtxt) mtxt.textContent = busy ? HB_STRINGS.cta_processing : HB_STRINGS.cta_purchase; }
  var online = $("hb-pay-online"), cod = $("hb-pay-cod");
  if (online) online.disabled = busy;
  if (cod) cod.disabled = busy;
}

function openPaymentChoice(){
  if (Object.keys(selected).length !== HAMPER_CONFIG.categories.length || checkoutBusy) return;
  var modal = $("hb-payment-choice");
  if (!modal) return;
  modal.classList.add("hb-payment-open");
  modal.setAttribute("aria-hidden", "false");
  document.body.style.overflow = "hidden";
  setTimeout(function(){ var first = $("hb-pay-online"); if (first) first.focus(); }, 20);
}

function closePaymentChoice(){
  if (checkoutBusy) return;
  var modal = $("hb-payment-choice");
  if (!modal) return;
  modal.classList.remove("hb-payment-open");
  modal.setAttribute("aria-hidden", "true");
  backToPaymentChoice();
  var drawer = $("hb-drawer");
  if (!drawer || !drawer.classList.contains("hb-open")) document.body.style.overflow = "";
}

/* 2026-10-22: "Add to Cart": the finished set goes into the SHARED cart (gb-cart.js), where the customer pays
   for everything at once (card or cash on delivery). The picks then reset, so another set can be built.
   (The old payment box below is no longer opened from here.) */
function addToCart(){
  var total = HAMPER_CONFIG.categories.length;
  if (Object.keys(selected).length !== total || checkoutBusy) return;
  var picks = HAMPER_CONFIG.categories.map(function(cat, i){
    var s = selected["c" + i];
    return { cat: cat.name, name: s.name, size: s.size, variantId: s.variantId, productId: s.productId, handle: s.handle, img: s.img, stock: s.stock };
  });
  /* the cart may have taken the last one since it was picked: reopen that step */
  for (var i = 0; i < total; i++) {
    gbSlot = "c" + i;
    if (gbLeft(selected["c" + i].variantId) <= 0) {
      delete selected["c" + i]; updateAll(); openSec("c" + i);
      showToast(GBCart.t.taken + " (" + HAMPER_CONFIG.categories[i].name + ")");
      return;
    }
  }
  var d = $("hb-drawer");
  if (d && d.classList.contains("hb-open")) toggleDrawer();
  GBCart.addSet({ name: HAMPER_CONFIG.cart_name || HAMPER_CONFIG.bundle_name, orderName: HAMPER_CONFIG.bundle_name,
                  price: HAMPER_CONFIG.fixed_price, img: picks[0].img, picks: picks, src: location.pathname });
  selected = {};
  HAMPER_CONFIG.categories.forEach(function(c, i){ rerenderCat(i); });
  updateAll();
  var s0 = $("sec-c0"), a0 = $("arrow-c0");
  if (s0) s0.classList.add("hb-open");
  if (a0) a0.classList.add("hb-rot");
}

function startStripeCheckout(){
  if (Object.keys(selected).length !== HAMPER_CONFIG.categories.length || checkoutBusy) return;
  setCheckoutBusy(true);
  var itemNames = Object.keys(selected).map(function(k){ return HAMPER_CONFIG.categories[parseInt(k.replace("c",""),10)].name + " - " + displayName(selected[k]); }).join(" + ");
  fetch(HAMPER_CONFIG.checkout_url, {
    method: "POST", headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ items: [{ name: HAMPER_CONFIG.bundle_name + " (" + itemNames + ")", price: HAMPER_CONFIG.fixed_price }], discount_percent: 0, success_url: HAMPER_CONFIG.success_url, cancel_url: window.location.href })
  })
  .then(function(r){ return r.json(); })
  .then(function(data){
    if (data.url) { window.location.href = data.url; }
    else { alert(HB_STRINGS.error_checkout); setCheckoutBusy(false); }
  })
  .catch(function(){ alert(HB_STRINGS.error_checkout); setCheckoutBusy(false); });
}

function showCodForm(){
  if (Object.keys(selected).length !== HAMPER_CONFIG.categories.length || checkoutBusy) return;
  prepareCodOrder();
  var main = $("hb-payment-main"), panel = $("hb-cod-panel"), dialog = document.querySelector(".hb-payment-dialog");
  if (main) main.hidden = true;
  if (panel) panel.hidden = false;
  if (dialog) dialog.classList.add("hb-cod-mode");
  setTimeout(function(){ var name = $("hb-cod-name"); if (name) name.focus(); }, 20);
}

function backToPaymentChoice(){
  var main = $("hb-payment-main"), panel = $("hb-cod-panel"), dialog = document.querySelector(".hb-payment-dialog");
  if (main) main.hidden = false;
  if (panel) panel.hidden = true;
  if (panel) panel.classList.remove("hb-cod-complete");
  if (dialog) dialog.classList.remove("hb-cod-mode");
  var form = $("hb-cod-form"), confirmation = $("hb-cod-confirmation");
  if (form) form.hidden = false;
  if (confirmation) confirmation.hidden = true;
}

function createCodReference(){
  var now = new Date();
  function pad(value){ return String(value).padStart(2, "0"); }
  var date = now.getFullYear() + pad(now.getMonth() + 1) + pad(now.getDate());
  return "GB-COD-" + date + "-" + Math.random().toString(36).slice(2, 7).toUpperCase();
}

function handleCodSubmit(){
  prepareCodOrder();
  try { sessionStorage.setItem("hb_cod_pending", "1"); } catch (e) {}
  var submit = document.querySelector("#hb-cod-form .hb-cod-submit");
  if (submit) {
    submit.disabled = true;
    if (submit.dataset.sending) submit.textContent = submit.dataset.sending;
  }
}

function prepareCodOrder(){
  if (Object.keys(selected).length !== HAMPER_CONFIG.categories.length) return true;
  var lines = HAMPER_CONFIG.categories.map(function(cat, i){
    return cat.name + ": " + displayName(selected["c" + i]);
  });
  var ids = HAMPER_CONFIG.categories.map(function(cat, i){ return selected["c" + i].variantId; });
  var items = $("hb-cod-selected-items"), variantIds = $("hb-cod-variant-ids"), body = $("hb-cod-body"), reference = $("hb-cod-reference");
  var referenceValue = reference && reference.value ? reference.value : createCodReference();
  if (items) items.value = lines.join(" | ");
  if (variantIds) variantIds.value = ids.join(", ");
  if (reference) reference.value = referenceValue;
  try { sessionStorage.setItem("hb_cod_reference", referenceValue); } catch (e) {}
  if (body) body.value = "NEW CASH ON DELIVERY ORDER\nReference: " + referenceValue
    + "\nBundle: " + HAMPER_CONFIG.bundle_name + "\nPrice: " + HB_PRICE_TEXT
    + "\n" + lines.join("\n") + "\nPage: " + window.location.href;
  return true;
}

function updateCodInquiry(referenceValue){
  var message = HB_COD_INQUIRY_TEMPLATE.replace("{order_id}", referenceValue || "");
  document.querySelectorAll(".hb-cod-inquiry-message-value").forEach(function(el){ el.textContent = message; });
  document.querySelectorAll(".hb-cod-whatsapp").forEach(function(el){
    el.href = "https://wa.me/971568177294?text=" + encodeURIComponent(message);
  });
  document.querySelectorAll(".hb-cod-instagram").forEach(function(el){ el.setAttribute("data-cod-message", message); });
}

function copyCodInquiry(event){
  var link = event.currentTarget;
  var message = link ? link.getAttribute("data-cod-message") : "";
  if (!message) return;
  try {
    var field = document.createElement("textarea");
    field.value = message;
    field.setAttribute("readonly", "");
    field.style.position = "fixed";
    field.style.opacity = "0";
    document.body.appendChild(field);
    field.select();
    document.execCommand("copy");
    document.body.removeChild(field);
  } catch (e) {}
  if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(message).catch(function(){});
  showToast(HB_COD_COPY_NOTICE, "success");
}

function showCodResultIfPresent(forceSuccess){
  var urlSuccess = forceSuccess === true;
  try {
    var params = new URLSearchParams(window.location.search);
    urlSuccess = urlSuccess || params.get("cod_order") === "success" || params.get("contact_posted") === "true" || params.get("form_type") === "contact";
    urlSuccess = urlSuccess || sessionStorage.getItem("hb_cod_pending") === "1";
  } catch (e) {}
  if ($("hb-cod-errors")) {
    urlSuccess = false;
    try { sessionStorage.removeItem("hb_cod_pending"); } catch (e) {}
  }
  if (!urlSuccess && !$("hb-cod-success") && !$("hb-cod-errors")) return;
  var modal = $("hb-payment-choice");
  if (!modal) return;
  modal.classList.add("hb-payment-open");
  modal.setAttribute("aria-hidden", "false");
  document.body.style.overflow = "hidden";
  backToPaymentChoice();
  var main = $("hb-payment-main"), panel = $("hb-cod-panel"), dialog = document.querySelector(".hb-payment-dialog");
  if (main) main.hidden = true;
  if (panel) panel.hidden = false;
  if (panel) panel.classList.toggle("hb-cod-complete", urlSuccess || !!$("hb-cod-success"));
  if (dialog) dialog.classList.add("hb-cod-mode");

  var referenceValue = "";
  try { referenceValue = sessionStorage.getItem("hb_cod_reference") || ""; } catch (e) {}
  document.querySelectorAll(".hb-cod-ref-value").forEach(function(el){ el.textContent = referenceValue; });
  updateCodInquiry(referenceValue);

  if (urlSuccess) {
    var form = $("hb-cod-form"), confirmation = $("hb-cod-confirmation");
    if (form) form.hidden = true;
    if (confirmation) confirmation.hidden = false;
    try { sessionStorage.removeItem("hb_cod_pending"); } catch (e) {}
    if (window.history && window.history.replaceState) {
      window.history.replaceState({}, document.title, window.location.pathname + window.location.hash);
    }
  }
}

function updateAll(){ gbRedrawCards(); buildTabs(); buildPanel(); buildBar(); gbSyncClear(); }

function init(){
  var container = $("hb-categories");
  GB_LOADING.then(function(results){
    HAMPER_CONFIG.categories.forEach(function(c, i){ catProducts["c" + i] = results[i]; });
    container.innerHTML = HAMPER_CONFIG.categories.map(function(c, i){ return sectionHTML(c, results[i], i); }).join("");
    var s = $("sec-c0"), a = $("arrow-c0"); if (s) s.classList.add("hb-open"); if (a) a.classList.add("hb-rot");
    updateAll(); initScrollSpy();
  }).catch(function(){ container.innerHTML = "<p style='padding:30px;color:#8a7a66;'>" + HB_STRINGS.error_loading + "</p>"; });
}

document.addEventListener("keydown", function(e){
  if (e.key !== "Escape") return;
  var payment = $("hb-payment-choice");
  if (payment && payment.classList.contains("hb-payment-open")) closePaymentChoice();
  else closeLB();
});
/* ── 2026-10-15: "Clear selection" ──
   A button under the picked items (side panel + phone drawer), shown only when something is picked.
   It asks "Start again?" in a small on-page box (not a browser pop-up) before removing everything. */
function gbPickedCount(){ return Array.isArray(selected) ? selected.length : Object.keys(selected).length; }
function gbSyncClear(){
  var show = gbPickedCount() > 0;
  ["hb-panel-items", "hb-drawer-items"].forEach(function(id){
    var list = $(id); if (!list) return;
    var wrap = $(id + "-clear");
    if (!wrap) {
      wrap = document.createElement("div"); wrap.id = id + "-clear"; wrap.className = "hb-clear-wrap";
      wrap.innerHTML = '<button type="button" class="hb-clear-btn" onclick="gbAskClear()"><span class="hb-clear-icon" aria-hidden="true">&#8634;</span>' + escHTML(HB_STRINGS.clear_btn) + '</button>';
      list.parentNode.insertBefore(wrap, list.nextSibling);
    }
    wrap.hidden = !show;
  });
}
function gbAskClear(){
  if (!gbPickedCount() || checkoutBusy) return;
  var box = $("hb-confirm");
  if (!box) {
    box = document.createElement("div"); box.id = "hb-confirm"; box.className = "hb-confirm";
    box.setAttribute("role", "dialog"); box.setAttribute("aria-modal", "true"); box.setAttribute("aria-labelledby", "hb-confirm-title");
    box.innerHTML = '<div class="hb-confirm-overlay" onclick="gbCloseClear()"></div><div class="hb-confirm-card">'
      + '<div class="hb-confirm-icon" aria-hidden="true">&#8634;</div>'
      + '<p class="hb-confirm-title" id="hb-confirm-title">' + escHTML(HB_STRINGS.clear_title) + '</p>'
      + '<p class="hb-confirm-text">' + escHTML(HB_STRINGS.clear_text) + '</p>'
      + '<div class="hb-confirm-actions"><button type="button" class="hb-confirm-no" onclick="gbCloseClear()">' + escHTML(HB_STRINGS.clear_no) + '</button>'
      + '<button type="button" class="hb-confirm-yes" onclick="gbConfirmClear()">' + escHTML(HB_STRINGS.clear_yes) + '</button></div></div>';
    ($("hb-root") || document.body).appendChild(box);
  }
  box.hidden = false;
  var no = box.querySelector(".hb-confirm-no"); if (no) no.focus();
}
function gbCloseClear(){ var box = $("hb-confirm"); if (box) box.hidden = true; }
function gbConfirmClear(){
  gbCloseClear();
  if (checkoutBusy) return;
  if (Array.isArray(selected)) { selected = []; renderGrid(); }
  else { selected = {}; HAMPER_CONFIG.categories.forEach(function(c, i){ rerenderCat(i); }); }
  updateAll(); buildDrawer(); showToast(HB_STRINGS.clear_done);
}
document.addEventListener("keydown", function(e){ if (e.key === "Escape") gbCloseClear(); });

/* 2026-10-22: the cart changed (here, in the cart window or in another tab): stock left may have changed */
GBCart.onChange(function(){ updateAll(); });
init();
var hbCodForm = $("hb-cod-form");
if (hbCodForm) hbCodForm.addEventListener("submit", handleCodSubmit);
showCodResultIfPresent();
